:host {
  display: grid;
  block-size: 100%;
  inline-size: 100%;
  align-items: center;
  justify-content: center;
}

.slide {
  display: grid;
  max-inline-size: 1100px;
  grid-template-columns: 1fr 550px;
  background-color: var(--color-accent-surface-elevation-1);
  border-radius: 16px;
  overflow: hidden;

  &__illustration {
    overflow: hidden;
    max-block-size: 700px;
  }

  &__sign-in {
    display: grid;
    block-size: 100%;
    inline-size: 100%;
    padding: 48px;
  }

  &__sign-in-container {
    display: grid;
    gap: var(--spacing-gap-xxl);
    max-inline-size: 480px;
    place-self: center;
  }

  &__sign-in-header {
    display: grid;
    gap: var(--spacing-gap-xxl);
  }

  &__sign-in-title {
    font-size: var(--font-size-header-h2);
    color: var(--color-text-neutral-strawberry);
    letter-spacing: 0.02em;
    font-weight: var(--font-style-semi-bold);
    line-height: var(--line-height-tight);
  }

  &__sign-in-description {
    display: grid;
    color: var(--color-text-neutral-disabled);
    gap: 40px;
    font-size: var(--font-size-body-l);
    font-weight: var(--font-style-regular);
    line-height: var(--line-height-spacious);
  }
}

.terms-conditions {
  text-decoration: underline;
}
.sign-in-btn {
  padding-inline-start: 48px !important;
  padding-inline-end: 48px !important;
}
